import type { Customer } from '@studio/types';

/**
 * Enriches the current Pendo account with customer plan/subscription metadata.
 *
 * Pendo is initialized (visitor + base account) on login in the authentication
 * saga; this augments that account with plan details once the customer record
 * has been fetched. Failures are swallowed so analytics never break the app.
 */
const identifyPendoCustomer = (customer: Customer.Get.Customer): void => {
  const {
    multisitePlanName,
    multisiteStartDate,
    subscriptionDetails,
    vodPlanName,
    vodStartDate,
    webPlanName,
    webStartDate,
  } = customer;

  try {
    pendo.identify({
      visitor: { id: pendo.getVisitorId() },
      account: {
        id: pendo.getAccountId(),
        multi_plan: multisitePlanName ?? '',
        multi_start_date: multisiteStartDate ?? '',
        live_plan: webPlanName ?? '',
        live_start_date: webStartDate ?? '',
        content_library_plan: vodPlanName ?? '',
        content_library_start_date: vodStartDate ?? '',
        studio_ai: Boolean(subscriptionDetails.aiVideosPerMonth),
        subtitles: Boolean(subscriptionDetails.subtitlesHoursPerMonth),
      },
    });
  } catch (pendoError) {
    console.error('error calling pendo.identify', pendoError);
  }
};

export default identifyPendoCustomer;
